define('Store.Session.EntryPoint', [
	'Profile.Model',
	'Session',
	'underscore'
], function StoreSessionEntryPoint(
	ProfileModel,
	Session,
	_
) {
	return {
		wrapSession: function wrapSession() {
			Session.getSearchApiParams = _.wrap(Session.getSearchApiParams, function wrapParams(fn) {
				var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
				_.extend(originalRet, {
					custitem_sca_store: ProfileModel.getInstance().get('store')
					&& ProfileModel.getInstance().get('store').get('name')
					&& ProfileModel.getInstance().get('store').get('name').replace(/ /g, '-')
				});
				return originalRet;
			});
		},
		mountToApp: function mountToApp() {
			this.wrapSession();
		}
	};
});
